/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : IMPORT PREVIEW: STYLES --------------- ++++++++++ */
export default theme =>({
  '@global': {
    '.tippy-tooltip-content': {
      wordBreak: 'initial !important',
      '& a': { textDecoration: 'underline' }
    }
  },
  importpreview: {
    padding: `${pxToEm(24)} ${pxToEm(36)}`,
    '& .title': {
      margin: 0
    },
    '& .previewtitle': {
      textAlign: 'center'
    },
    '& label': {
      color: themeV2.color.primary.main
    },
    '& .importpreviewheader': {
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'end',
      justifyContent: 'space-between',
      '& .articleurlsdropdown': {
        width: '100%',
        maxWidth: '82%',
        marginRight: pxToEm(16),
        marginBottom: pxToEm(16),
        zIndex: 2,
        '& label': {
          display: 'block',
          marginBottom: pxToEm(4)
        },
        '& .singleselectdropdown': {
          width: '100% !important'
        },
        '& .placeholdertext, & .itemtext': {
          whiteSpace: 'nowrap'
        }
      },
      '& .threadscountwrapper': {
        display: 'flex',
        alignItems: 'end',
        width: pxToEm(190),
        marginBottom: pxToEm(16),
        zIndex: 1,
        '& .name-threadscount': {
          marginRight: pxToEm(8)
        },
        '& .name-loadbtn': {
          width: pxToEm(50)
        },
      }
    },
    '& .previewcontainer': {
      display: 'flex',
      width: '100%',
      height: '100%',
      justifyContent: 'space-between',
      marginBottom: pxToEm(24),
      '& .pagepreview': {
        flex: 1,
        margin: pxToEm(8),
        height: '100%',
        '& .pagepreviewheader': {
          background: themeV2.color.base.gray.light,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: `${pxToEm(8)} ${pxToEm(16)}`,
          '& .group': {
            '& .button': {
              width: pxToEm(70),
              margin: `0 ${pxToEm(4)}`,
              height: pxToEm(40)
            }
          }
        },
        '& .iframe': {
          height: '90%',
        }
      }
    }
  }
});
